<template>
  <div>
    <div class="row">
      <div class="col-xl-6 col-lg-12">
        <inspector-team-details/>
      </div>
      <div class="col-xl-6 col-lg-12">
        <inspector-team-members/>
      </div>
    </div>
    <div class="row" v-if="$auth.can({pt_lock: 'read'}, 'permissions')">
      <div class="col-12">
        <pt-locks-table :team-id="$route.params.id"/>
      </div>
    </div>
  </div>
</template>
<script>
  import InspectorTeamDetails from './InspectorTeam/InspectorTeamDetails';
  import InspectorTeamMembers from './InspectorTeam/InspectorTeamMembers';
  import PtLocksTable from 'src/pages/PtLocks/PtLocksTable'

  export default {
    components: {
      InspectorTeamDetails,
      InspectorTeamMembers,
      PtLocksTable
    },
    methods: {},
    mounted() {
    },
  };
</script>
<style></style>
